// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"34dd78d8","453":"90a8d5c9","732":"1366e813"}[chunkId] + ".chunk.js";
};